import { Page } from '@/components';
import Kpis from './KPIs';
import AtRiskTabs from './AtRiskTabs';
import WalletsAtRiskTable from './WalletsAtRiskTable';
export default function RiskPage() {
  return (
    <Page title={'Collateral at risk'}>
      <Kpis />
      <AtRiskTabs />
      <WalletsAtRiskTable />
    </Page>
  );
}
